export default __webpack_public_path__ + "0bbbffa785e627c3e9d6af904827b16a.png";